import React, { useEffect, useState } from 'react';
import CommonPagination from '../../Common/CommonPagination';
import CommonContainer from "../Container/CommonContainer";
import { FaSearch, FaFileCode } from "react-icons/fa";
import * as ElmahErrorsService from '../../Services/ElmahErrors/ElmahErrorsService';
import './ElmahErrorsComponent.css';

const ElmahErrorsComponent = () => {
    const [elmahErrors, setElmahErrors] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState("");

    useEffect(() => {
        getElmahErrors();
    }, []);

    const formatToIST = (utcTime) => {
        if (!utcTime) return "";
        const date = new Date(utcTime);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            hour12: true,
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    };

    const getElmahErrors = () => {
        ElmahErrorsService.GetElmahErrors()
            .then(({ data }) => {
                if (data.IsSuccess) {
                    const processedData = data.Data.map((error) => ({
                        ...error,
                        FormattedTime: formatToIST(error.TimeUtc), 
                    }));
                    setElmahErrors(processedData);
                } else {
                    setElmahErrors([]);
                }
            })
            .catch(() => {
                setElmahErrors([]);
            });
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const cleanXML = (xmlString) => {
        if (!xmlString) return "";
        return xmlString.replace(/\\r\\n/g, "\n").replace(/\\"/g, '"');
    };

    const openModal = (xmlContent) => {
        setModalContent(cleanXML(xmlContent));
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalContent("");
    };

    const filteredErrors = elmahErrors.filter((error) => {
        const lowerSearch = searchTerm.toLowerCase();
        return (
            error.Application?.toLowerCase().includes(lowerSearch) ||
            error.Type?.toLowerCase().includes(lowerSearch) ||
            error.Message?.toLowerCase().includes(lowerSearch) ||
            error.StatusCode?.toString().includes(searchTerm) ||
            error.FormattedTime?.toLowerCase().includes(lowerSearch) // Search formatted date
        );
    });

    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentErrors = filteredErrors.slice(indexOfFirst, indexOfLast);

    return (
        <>
            <CommonContainer heading="Error Logs">
                <div className="d-flex flex-column flex-lg-row mb-2 date-search-content gap-2 search-sm" style={{ float: "right" }}>
                    <div className="search-box" style={{ position: "relative" }}>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={handleSearch}
                            style={{ paddingRight: "35px", borderRadius: "5px", border: "1px solid #ddd" }}
                        />
                        <button
                            className="btn custom-sumbitbtn d-flex align-items-center justify-content-center search-box-btn"
                            style={{
                                padding: '5px',
                                position: "absolute",
                                right: "0px",
                                height: "35px",
                                width: "45px",
                                top: "50%",
                                borderTopLeftRadius: "0",
                                borderBottomLeftRadius: "0",
                                transform: "translateY(-45%)"
                            }}
                            onClick={() => setCurrentPage(1)}
                        >
                            <FaSearch />
                        </button>
                    </div>
                </div>

                <div className="mt-3 mt-lg-2">
                    <div className="table-responsive">
                        <table className="table table-bordered custom-table">
                            <thead>
                                <tr>
                                    <th style={{ width: "18%" }}>Application</th>
                                    <th style={{ width: "12%" }}>Type</th>
                                    <th style={{ width: "32%" }}>Message</th>
                                    <th style={{ width: "10%" }}>StatusCode</th>
                                    <th style={{ width: "18%" }}>Time (IST)</th>
                                    <th style={{ width: "10%" }}>AllXML</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "10px" }}>
                                {currentErrors.length > 0 ? (
                                    currentErrors.map((error, index) => (
                                        <tr key={index}>
                                            <td>{error.Application}</td>
                                            <td>{error.Type}</td>
                                            <td>{error.Message}</td>
                                            <td>{error.StatusCode}</td>
                                            <td>{error.FormattedTime}</td>
                                            <td>
                                                <button
                                                    className="btn btn-sm elmaherrorxmlicon"
                                                    title="View XML"
                                                    style={{
                                                        borderRadius: "5px",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    onClick={() => openModal(error.AllXml)}
                                                >
                                                    <FaFileCode title='View XML' size={14} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            No Errors found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {filteredErrors.length > itemsPerPage && (
                        <CommonPagination
                            pageList={filteredErrors}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            setCurrentPage={setCurrentPage}
                        />
                    )}
                </div>
            </CommonContainer>

            {isModalOpen && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                    onClick={closeModal}
                >
                    <div
                        className="modal-dialog modal-xl modal-dialog-centered"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-content" style={{ maxHeight: "90vh" }}>
                            <div className="modal-header">
                                <h5 className="modal-title">Error XML</h5>
                                <button type="button" className="btn-close" onClick={closeModal}></button>
                            </div>

                            <div
                                className="modal-body"
                                style={{
                                    overflowY: "auto",
                                    maxHeight: "70vh",
                                    backgroundColor: "#f8f9fa",
                                    padding: "15px",
                                    border: "1px solid #ddd",
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                    fontFamily: "monospace",
                                    fontSize: "12px",
                                }}
                            >
                                {modalContent}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ElmahErrorsComponent;